module.exports = __webpack_public_path__ + "static/media/light9.3e839af9.png";